import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConnectCoreModule } from '@aveva/connect-web-core';
import { ErmDevOpsRoutingModule } from './erm-devops-routing.module';
import { ErmDevOpsGuard } from './erm-devops.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AccountListComponent } from './account-list/account-list.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { EnvironmentListComponent } from './environment-list/environment-list.component';
import { EnvironmentDetailsComponent } from './environment-details/environment-details.component';
import { WidgetComponent } from './dashboard/widgets/widget.component';
import { SlaAlarmsWidgetComponent } from './dashboard/widgets/sla-alarms-widget.component';
import { NonSlaAlarmsWidgetComponent } from './dashboard/widgets/non-sla-alarms-widget.component';
import { StatsWidgetComponent } from './dashboard/widgets/stats-widget.component';
import { UnauthorizedComponent } from './authorization/unauthorized.component';
import { UnauthorizedGuard } from './authorization/unauthorized.guard';
import { AlarmListComponent } from './alarms/alarm-list.component';
import { GlobalAlarmsWidgetComponent } from './dashboard/widgets/global-alarms-widget.component';
import { CreateFleetDefinitionComponent } from './create-fleet-definition/create-fleet-definition.component';
import { UpdateFleetConfigurationComponent } from './update-fleet-configuration/update-fleet-configuration.component';
import { CreateEnvironmentComponent } from './create-environment/create-environment.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { DevopsActionsListComponent } from './devops-actions/devops-actions-list.component';
import { CreateDevopsActionDialogComponent } from './create-devops-action/dialog/create-devops-action-dialog.component';
import { CreateDevopsActionComponent } from './create-devops-action/page/create-devops-action.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UpdateEnvironmentComponent } from './update-environment/update-environment.component';
import { AddNewDevOpsActionParameterComponent } from './add-new-dev-ops-action-parameter/add-new-dev-ops-action-parameter.component';
import { FleetUsersComponent } from './fleet-users/fleet-users.component';
import { CreateFleetUserComponent } from './create-fleet-user/create-fleet-user.component';
import { UpdateFleetUserComponent } from './update-fleet-user/update-fleet-user.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { ErmSdkModule } from 'erm-sdk';

ModuleRegistry.registerModules([AllCommunityModule]);

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ConnectCoreModule,
    ErmDevOpsRoutingModule,
    ErmSdkModule,
    FlexLayoutModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    ErmDevOpsGuard,
    UnauthorizedGuard
  ],
  declarations: [
    AccountListComponent,
    AccountDetailsComponent,
    AlarmListComponent,
    CustomerListComponent,
    CustomerDetailsComponent,
    DashboardComponent,
    EnvironmentListComponent,
    EnvironmentDetailsComponent,
    GlobalAlarmsWidgetComponent,
    NonSlaAlarmsWidgetComponent,
    SlaAlarmsWidgetComponent,
    StatsWidgetComponent,
    WidgetComponent,
    UnauthorizedComponent,
    CreateFleetDefinitionComponent,
    UpdateFleetConfigurationComponent,
    CreateEnvironmentComponent,
    CreateAccountComponent,
    DevopsActionsListComponent,
    CreateDevopsActionDialogComponent,
    CreateDevopsActionComponent,
    UpdateEnvironmentComponent,
    AddNewDevOpsActionParameterComponent,
    FleetUsersComponent,
    CreateFleetUserComponent,
    UpdateFleetUserComponent,
  ]
})
export class ErmDevOpsModule { }
